import React from 'react';

import './index.sass';

export default function NewsPic({ url = '', tips = '', img = '', title = '', date = '', text = '', info }) {
  return (
    <div className='news-pic'>
      <div
        className='trangle-placeholder'
      >
        <div>
          <div className='image' style={{
            backgroundImage: `url(${img})`,
          }}></div>
          {
            info ? <div className='tip' onClick={() => {
              if (url) window.open(url);
            }}>
              <div className='title'>{info.title}</div>
              <div className='subtitle'>{info.subtitle}</div>
              <div className='date'>{info.date}</div>
              <div className='text'>{info.text}</div>
              <div className='button'>了解详情</div>
            </div> : <div className='tip' style={{
              backgroundImage: `url(${tips})`,
            }} onClick={() => {
              if (url) window.open(url);
            }}></div>
          }
        </div>
      </div>
    </div>
  );
}
